import React, { useState, useEffect } from "react";
import { useList } from "store/list";
import * as Icons from "react-feather";

export default function ListPagination(props) {
  const listStore = useList();
  return (
    <>
      <div className="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-nowrap items-center justify-between">
        <ul className="flex w-full justify-center">
          {listStore.page > 1 && (
            <>
              <li className="p-2">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    props.getList(1);
                  }}
                  className="pagination__link"
                >
                  <Icons.ChevronsRight className="w-4 h-4" />
                </a>
              </li>
              <li className="p-2">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    props.getList(listStore.page - 1);
                  }}
                  className="pagination__link"
                >
                  <Icons.ChevronRight className="w-4 h-4" />
                </a>
              </li>
            </>
          )}

          {/* page numbers */}
          {listStore.page > 2 && (
            <>
              <li className={`p-2 ${listStore.page == 1 ? "pg-active" : ""}`}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    props.getList(1);
                  }}
                  className="pagination__link"
                >
                  1
                </a>
              </li>
              <li className={`p-2 ${listStore.page == 2 ? "pg-active" : ""}`}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    props.getList(2);
                  }}
                  className="pagination__link "
                >
                  2
                </a>
              </li>
              <li className="p-2">
                <a href="#" className="pagination__link">
                  ...
                </a>
              </li>
            </>
          )}

          {listStore.page > 1 && listStore.page < 3 && (
            <li
              className={`p-2 ${
                listStore.page == listStore.page - 1 ? "pg-active" : ""
              }`}
            >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  props.getList(listStore.page - 1);
                }}
                className="pagination__link"
              >
                {listStore.page - 1}
              </a>
            </li>
          )}
          <li
            className={`p-2 ${
              listStore.page == listStore.page ? "pg-active" : ""
            }`}
          >
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                props.getList(listStore.page);
              }}
              className="pagination__link"
            >
              {listStore.page}
            </a>
          </li>

          {listStore.page <= listStore.lastPage - 1 && (
            <li
              className={`p-2 ${
                listStore.page == listStore.page + 1 ? "pg-active" : ""
              }`}
            >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  props.getList(listStore.page + 1);
                }}
                className="pagination__link"
              >
                {listStore.page + 1}
              </a>
            </li>
          )}

          {listStore.page <= listStore.lastPage - 2 && (
            <li
              className={`p-2 ${
                listStore.page == listStore.page + 2 ? "pg-active" : ""
              }`}
            >
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  props.getList(listStore.page + 1);
                }}
                className="pagination__link"
              >
                {listStore.page + 2}
              </a>
            </li>
          )}

          {listStore.page < listStore.lastPage - 2 && (
            <>
              <li className="p-2">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  className="pagination__link"
                >
                  ...
                </a>
              </li>
              <li
                className={`p-2 ${
                  listStore.page == listStore.lastPage ? "pg-active" : ""
                }`}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    props.getList(listStore.lastPage);
                  }}
                  className="pagination__link"
                >
                  {listStore.lastPage}
                </a>
              </li>
            </>
          )}
          {/* page numbers */}

          {listStore.page < listStore.lastPage && (
            <>
              <li className="p-2">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    props.getList(listStore.page + 1);
                  }}
                  className="pagination__link"
                >
                  <Icons.ChevronLeft className="w-4 h-4" />
                </a>
              </li>
              <li className="p-2">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    props.getList(listStore.lastPage);
                  }}
                  className="pagination__link"
                >
                  <Icons.ChevronsLeft className="w-4 h-4" />
                </a>
              </li>
            </>
          )}
        </ul>
        <select
          defaultValue={listStore.perPage}
          onChange={(e) => props.getList(1, Number(e.target.value))}
          className="w-20 form-select box mt-3 sm:mt-0"
        >
          <option value="10">10</option>
          <option value="15">15</option>
          <option value="20">20</option>
          <option value="40">40</option>
          <option value="50">50</option>
        </select>
      </div>
    </>
  );
}
